var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftCircuit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 629,
    viewBox: "0 0 396 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.364 0.513684C124.737 -0.413213 126.602 -0.0511943 127.529 1.32125C128.456 2.69369 128.094 4.55941 126.722 5.48631C125.349 6.41321 123.484 6.05121 122.557 4.67877C121.63 3.30632 121.992 1.44058 123.364 0.513684Z",
    fill: "url(#paint0_linear_1857_4481)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.253 543.54L277.741 547.609L280.891 549.53L277.277 550.269L275.438 553.931L274.949 549.862L271.799 547.941L275.414 547.202L277.253 543.54Z",
    fill: "#15BFFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5315 436L103.471 426.544H201.108L222.813 414.794H309.043V414H222.614L200.905 425.754H103.196L91.043 435.378L91.5315 436Z",
    fill: "url(#paint1_linear_1857_4481)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9034 438.355C91.6036 439.38 89.7134 439.16 88.6882 437.86C87.663 436.561 87.8826 434.67 89.1824 433.645C90.4822 432.62 92.3726 432.839 93.3978 434.144C94.423 435.444 94.2032 437.334 92.9034 438.359V438.355Z",
    fill: "url(#paint2_linear_1857_4481)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5303 425L99.4379 415.544H196.846L218.5 403.794H310.043V403H218.302L196.648 414.749H99.1672L87.043 424.378L87.5303 425Z",
    fill: "url(#paint3_linear_1857_4481)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1836 421.647C84.8847 422.671 84.6606 424.56 85.6897 425.859C86.7143 427.158 88.6033 427.382 89.9023 426.353C91.2013 425.324 91.4253 423.44 90.3962 422.141C89.3716 420.842 87.4826 420.618 86.1836 421.647Z",
    fill: "url(#paint4_linear_1857_4481)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1836 421.647C84.8847 422.671 84.6606 424.56 85.6897 425.859C86.7143 427.158 88.6033 427.382 89.9023 426.353C91.2013 425.324 91.4253 423.44 90.3962 422.141C89.3716 420.842 87.4826 420.618 86.1836 421.647Z",
    fill: "url(#paint5_linear_1857_4481)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.022 344L274.108 343.954L299.497 330.492H371.043V329.682H299.302L299.216 329.728L273.833 343.19L241.761 342.945L222.238 319H116.41L94.7226 330.973H0.0429688V331.778H94.9214L116.609 319.805H221.872L241.39 343.75L274.022 344Z",
    fill: "url(#paint6_linear_1857_4481)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M273.914 329L274 328.954L299.417 315.492H371.043V314.682H299.222L299.136 314.728L273.724 328.19L241.616 327.95L222.072 304H119.043V304.805H221.705L241.245 328.755L273.914 329Z",
    fill: "url(#paint7_linear_1857_4481)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M119.043 308C117.386 308 116.043 306.657 116.043 305C116.043 303.343 117.386 302 119.043 302C120.7 302 122.043 303.343 122.043 305C122.043 306.657 120.7 308 119.043 308Z",
    fill: "url(#paint8_linear_1857_4481)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M216.043 272H311.316L333.191 258.882H370.043V258H332.99L311.116 271.118H216.043V272Z",
    fill: "url(#paint9_linear_1857_4481)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.043 268C214.388 268 213.043 269.345 213.043 271C213.043 272.655 214.388 274 216.043 274C217.698 274 219.043 272.655 219.043 271C219.043 269.345 217.698 268 216.043 268Z",
    fill: "url(#paint10_linear_1857_4481)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.167 294H201.312L215.532 282.152H312.92L334.57 269.829H371.043V269H334.371L312.722 281.324H215.261L201.042 293.171H152.442L138.963 281.943H90.043V282.771H138.688L152.167 294Z",
    fill: "url(#paint11_linear_1857_4481)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9777 285.07C88.3422 284.805 87.2311 283.265 87.496 281.629C87.7609 279.994 89.3015 278.882 90.937 279.147C92.5726 279.412 93.6837 280.953 93.4188 282.588C93.1539 284.224 91.6133 285.335 89.9777 285.07Z",
    fill: "url(#paint12_linear_1857_4481)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M292.182 233H365.043V232.244H292.379L270.843 221H177.043V221.756H270.646L292.182 233Z",
    fill: "url(#paint13_linear_1857_4481)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.043 218C174.388 218 173.043 219.345 173.043 221C173.043 222.655 174.388 224 176.043 224C177.698 224 179.043 222.655 179.043 221C179.043 219.345 177.698 218 176.043 218Z",
    fill: "url(#paint14_linear_1857_4481)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M268.601 162L269.043 161.347L208.972 120.568L197.987 98.8236L197.902 98.7691L102.485 34L102.043 34.6534L197.378 99.3681L208.362 121.108L208.444 121.167L268.601 162Z",
    fill: "url(#paint15_linear_1857_4481)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.722 32.5137C104.349 31.5868 102.484 31.9488 101.557 33.3212C100.63 34.6937 100.992 36.5594 102.364 37.4863C103.737 38.4132 105.602 38.0512 106.529 36.6788C107.456 35.3063 107.094 33.4406 105.722 32.5137Z",
    fill: "url(#paint16_linear_1857_4481)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.673 187L230.043 186.307L166.065 151.707L154.707 134L154.043 134.426L165.514 152.306L165.604 152.351L229.673 187Z",
    fill: "url(#paint17_linear_1857_4481)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.566 133.376C156.667 131.983 154.812 131.582 153.419 132.477C152.026 133.372 151.624 135.231 152.52 136.624C153.415 138.017 155.274 138.418 156.667 137.523C158.06 136.628 158.461 134.769 157.566 133.376Z",
    fill: "url(#paint18_linear_1857_4481)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M297.31 184L298.043 183.687L288.231 160.001L288.13 159.932L235.489 124L235.043 124.663L287.589 160.53L297.31 184Z",
    fill: "url(#paint19_linear_1857_4481)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.502 121.599C235.9 120.518 233.724 120.94 232.642 122.541C231.561 124.143 231.983 126.319 233.584 127.401C235.186 128.482 237.362 128.06 238.444 126.459C239.525 124.857 239.103 122.681 237.502 121.599Z",
    fill: "url(#paint20_linear_1857_4481)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.742 214H250.043V213.307H176.941L155.274 203H39.043V203.693H155.076L176.742 214Z",
    fill: "url(#paint21_linear_1857_4481)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.043 200C37.3878 200 36.043 201.345 36.043 203C36.043 204.655 37.3878 206 39.043 206C40.6981 206 42.043 204.655 42.043 203C42.043 201.345 40.6981 200 39.043 200Z",
    fill: "url(#paint22_linear_1857_4481)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M229.043 243H260.043V244H229.043V243Z",
    fill: "url(#paint23_linear_1857_4481)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M230.043 246C228.386 246 227.043 244.657 227.043 243C227.043 241.343 228.386 240 230.043 240C231.7 240 233.043 241.343 233.043 243C233.043 244.657 231.7 246 230.043 246Z",
    fill: "url(#paint24_linear_1857_4481)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M278.121 239H371.043V238.293H278.392L269.539 232H135.043V232.711H269.268L278.121 239Z",
    fill: "url(#paint25_linear_1857_4481)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M136.043 235C134.387 235 133.043 233.656 133.043 232C133.043 230.345 134.387 229 136.043 229C137.698 229 139.043 230.345 139.043 232C139.043 233.656 137.698 235 136.043 235Z",
    fill: "url(#paint26_linear_1857_4481)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.043 256H291.125L307.837 248.668H371.043V248H307.643L307.557 248.038L290.935 255.332H194.043V256Z",
    fill: "url(#paint27_linear_1857_4481)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M194.043 259C192.387 259 191.043 257.656 191.043 256C191.043 254.345 192.387 253 194.043 253C195.698 253 197.043 254.345 197.043 256C197.043 257.656 195.698 259 194.043 259Z",
    fill: "url(#paint28_linear_1857_4481)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M152.731 602.719L154.445 535.508L247.313 449.352L246.776 448.773L153.662 535.155L151.945 602.701L152.731 602.719Z",
    fill: "url(#paint29_linear_1857_4481)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M155.305 602.638C155.264 604.275 153.903 605.568 152.267 605.527C150.631 605.486 149.338 604.126 149.378 602.489C149.419 600.853 150.78 599.56 152.416 599.601C154.053 599.641 155.345 601.002 155.305 602.638Z",
    fill: "url(#paint30_linear_1857_4481)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M235.075 616.751H235.866L235.776 582.766L235.663 582.653L195.779 541.788L196.936 496.298L196.149 496.275L194.983 542.1L234.989 583.091L235.075 616.751Z",
    fill: "url(#paint31_linear_1857_4481)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M238.436 616.593C238.436 618.229 237.116 619.563 235.479 619.563C233.843 619.563 232.509 618.243 232.509 616.607C232.509 614.97 233.829 613.637 235.466 613.637C237.102 613.637 238.436 614.957 238.436 616.593Z",
    fill: "url(#paint32_linear_1857_4481)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M197.814 626.131L198.447 601.282L153.812 555.553L153.251 556.104L197.652 601.594L197.028 626.113L197.814 626.131Z",
    fill: "url(#paint33_linear_1857_4481)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.385 626.05C200.344 627.687 198.983 628.98 197.347 628.939C195.711 628.898 194.418 627.538 194.458 625.901C194.499 624.265 195.86 622.972 197.496 623.013C199.133 623.053 200.425 624.414 200.385 626.05Z",
    fill: "url(#paint34_linear_1857_4481)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3418 512.445L110.452 470.595L190.32 472.529L190.437 472.421L232.103 433.766L231.565 433.188L190.017 471.734L110.149 469.799L110.036 469.907L64.8038 511.867L65.3418 512.445Z",
    fill: "url(#paint35_linear_1857_4481)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1944 514.226C65.9965 515.338 64.1205 515.27 63.0039 514.067C61.8919 512.869 61.9597 510.993 63.1622 509.877C64.3601 508.765 66.2361 508.833 67.3527 510.035C68.4647 511.233 68.3969 513.109 67.1944 514.226Z",
    fill: "url(#paint36_linear_1857_4481)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0526 515.375L115.039 497.759L146.063 498.51L174.601 472.038L174.063 471.459L145.76 497.714L114.736 496.964L95.5147 514.797L96.0526 515.375Z",
    fill: "url(#paint37_linear_1857_4481)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9073 517.157C96.7094 518.269 94.8335 518.201 93.7169 516.999C92.6049 515.801 92.6726 513.925 93.875 512.808C95.073 511.696 96.949 511.764 98.0655 512.967C99.1776 514.165 99.1098 516.041 97.9073 517.157Z",
    fill: "url(#paint38_linear_1857_4481)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.338 554.449L131.544 531.069L132.371 498.558L131.585 498.535L130.762 530.717L105.8 553.87L106.338 554.449Z",
    fill: "url(#paint39_linear_1857_4481)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.195 556.235C106.997 557.347 105.121 557.28 104.005 556.077C102.893 554.879 102.961 553.003 104.163 551.887C105.361 550.775 107.237 550.842 108.354 552.045C109.466 553.243 109.398 555.119 108.195 556.235Z",
    fill: "url(#paint40_linear_1857_4481)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M280.145 578.602L280.71 578.051L257.375 554.146L257.217 554.142L206.484 552.912L206.461 553.703L257.036 554.928L280.145 578.602Z",
    fill: "url(#paint41_linear_1857_4481)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M282.447 576.153C283.59 577.324 283.568 579.2 282.397 580.343C281.226 581.487 279.35 581.464 278.207 580.294C277.063 579.123 277.085 577.247 278.256 576.103C279.427 574.959 281.303 574.982 282.447 576.153Z",
    fill: "url(#paint42_linear_1857_4481)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M249.766 358L250.043 357.262L224.814 348H164.043V348.792H224.673L249.766 358Z",
    fill: "url(#paint43_linear_1857_4481)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M164.043 345C162.387 345 161.043 346.344 161.043 348C161.043 349.655 162.387 351 164.043 351C165.698 351 167.043 349.655 167.043 348C167.043 346.344 165.698 345 164.043 345Z",
    fill: "url(#paint44_linear_1857_4481)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M202.043 371H221.151L221.258 370.907L235.043 358.62L234.542 358L220.868 370.188H202.043V371Z",
    fill: "url(#paint45_linear_1857_4481)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M202.043 374C200.387 374 199.043 372.655 199.043 371C199.043 369.344 200.387 368 202.043 368C203.698 368 205.043 369.344 205.043 371C205.043 372.655 203.698 374 202.043 374Z",
    fill: "url(#paint46_linear_1857_4481)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.508 409H179.923L194.22 396.85H292.043V396H193.948L179.651 408.145H130.78L117.231 396.63H68.043V397.485H116.954L130.508 409Z",
    fill: "url(#paint47_linear_1857_4481)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1585 400.599C66.3268 400.165 65.1938 398.329 65.6279 396.497C66.0619 394.665 67.8985 393.532 69.7302 393.966C71.562 394.4 72.695 396.237 72.261 398.069C71.827 399.9 69.9903 401.033 68.1585 400.599Z",
    fill: "url(#paint48_linear_1857_4481)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M130.508 252H179.923L194.22 239.85H292.043V239H193.948L179.651 251.145H130.78L117.231 239.635H68.043V240.485H116.954L130.508 252Z",
    fill: "url(#paint49_linear_1857_4481)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7541 243.041C67.1418 242.659 66.1446 241.043 66.5266 239.43C66.9086 237.818 68.5252 236.821 70.1374 237.203C71.7497 237.585 72.747 239.201 72.365 240.814C71.983 242.426 70.3663 243.423 68.7541 243.041Z",
    fill: "url(#paint50_linear_1857_4481)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M172.634 383H221.808L236.036 371.721H333.525L379.043 333.607L378.542 333L333.241 370.927H235.765L221.537 382.207H172.905L159.531 371.603L159.043 372.224L172.634 383Z",
    fill: "url(#paint51_linear_1857_4481)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M172.043 389H221.131L235.373 377.547H332.963L378.043 338.612L377.537 338L332.673 376.742H235.102L220.86 388.199H172.043V389Z",
    fill: "url(#paint52_linear_1857_4481)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.553 376L155.043 375.346L141.369 364H121.043V364.835H141.092L154.553 376Z",
    fill: "url(#paint53_linear_1857_4481)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M120.543 368C118.612 368 117.043 366.431 117.043 364.5C117.043 362.569 118.612 361 120.543 361C122.474 361 124.043 362.569 124.043 364.5C124.043 366.431 122.474 368 120.543 368Z",
    fill: "url(#paint54_linear_1857_4481)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M240.043 391H260.365L274.043 380.595L273.553 380L260.092 390.238H240.043V391Z",
    fill: "url(#paint55_linear_1857_4481)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M240.043 393C238.388 393 237.043 391.655 237.043 390C237.043 388.345 238.388 387 240.043 387C241.698 387 243.043 388.345 243.043 390C243.043 391.655 241.698 393 240.043 393Z",
    fill: "url(#paint56_linear_1857_4481)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M373.034 223L373.043 222.224L291.37 221.404L261.348 197.581H261.212L176.268 196.729L156.253 180.847L156.117 180.843L72.052 180L72.043 180.78L155.972 181.623L175.987 197.505L212.719 197.871L261.067 198.357L291.089 222.18H291.225L373.034 223Z",
    fill: "url(#paint57_linear_1857_4481)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0132 184C70.3566 183.982 69.0248 182.627 69.0432 180.97C69.0615 179.314 70.4161 177.982 72.0727 178C73.7294 178.018 75.0611 179.373 75.0428 181.03C75.0245 182.686 73.6698 184.018 72.0132 184Z",
    fill: "url(#paint58_linear_1857_4481)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M373.034 212L373.043 211.22L296.68 210.444L267.544 187.09H267.409L190.153 186.305L164.287 165.569L94.0746 163L94.043 163.78L163.994 166.345L189.873 187.085L221.625 187.408L267.265 187.87L296.396 211.224H296.531L373.034 212Z",
    fill: "url(#paint59_linear_1857_4481)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9331 165.998C91.2762 165.938 89.9854 164.542 90.0449 162.89C90.1044 161.233 91.5005 159.942 93.1528 160.002C94.8097 160.061 96.1005 161.457 96.041 163.11C95.9815 164.767 94.5855 166.062 92.9331 165.998Z",
    fill: "url(#paint60_linear_1857_4481)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.781 188L137.043 181.649L136.552 181L128.513 187.183L104.052 186.931L104.043 187.743L128.781 188Z",
    fill: "url(#paint61_linear_1857_4481)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M105.073 184C103.416 183.982 102.057 185.314 102.043 186.97C102.025 188.627 103.357 189.986 105.013 190C106.67 190.018 108.029 188.686 108.043 187.03C108.061 185.373 106.729 184.014 105.073 184Z",
    fill: "url(#paint62_linear_1857_4481)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M247.581 499L261.319 486.346L278.043 484.721L277.964 484L260.971 485.646L260.878 485.733L247.043 498.479L247.581 499Z",
    fill: "url(#paint63_linear_1857_4481)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M250.135 501.148C248.95 502.305 247.049 502.281 245.895 501.092C244.738 499.907 244.762 498.006 245.951 496.852C247.136 495.695 249.037 495.719 250.191 496.908C251.348 498.093 251.324 499.994 250.135 501.148Z",
    fill: "url(#paint64_linear_1857_4481)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M215.568 496L256.148 460.751H310.043V460H255.847L255.735 460.095L215.043 495.444L215.568 496Z",
    fill: "url(#paint65_linear_1857_4481)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M217.054 498.226C215.825 499.336 213.927 499.241 212.817 498.011C211.707 496.782 211.802 494.884 213.032 493.774C214.261 492.664 216.159 492.759 217.269 493.989C218.379 495.218 218.284 497.116 217.054 498.226Z",
    fill: "url(#paint66_linear_1857_4481)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M265.898 417.365L266.402 417.969L178.579 491.244L178.075 490.64L265.898 417.365Z",
    fill: "url(#paint67_linear_1857_4481)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M180.964 492.303C179.691 493.365 177.802 493.194 176.74 491.921C175.678 490.648 175.849 488.759 177.122 487.697C178.395 486.635 180.284 486.806 181.346 488.079C182.408 489.352 182.237 491.241 180.964 492.303Z",
    fill: "url(#paint68_linear_1857_4481)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M283.248 411.212L283.752 411.816L195.929 485.092L195.425 484.488L283.248 411.212Z",
    fill: "url(#paint69_linear_1857_4481)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M198.964 487.303C197.691 488.365 195.802 488.194 194.74 486.921C193.678 485.648 193.849 483.759 195.122 482.697C196.395 481.635 198.284 481.806 199.346 483.079C200.408 484.352 200.237 486.241 198.964 487.303Z",
    fill: "url(#paint70_linear_1857_4481)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M239.595 530L373.146 400.112V358.794L395.029 359.078L395.043 358.289L372.355 358V399.779L239.043 529.436L239.595 530Z",
    fill: "url(#paint71_linear_1857_4481)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M240.287 531.289C239.3 532.254 237.714 532.235 236.754 531.244C235.789 530.257 235.808 528.671 236.799 527.711C237.786 526.746 239.372 526.765 240.332 527.756C241.297 528.743 241.278 530.329 240.287 531.289Z",
    fill: "url(#paint72_linear_1857_4481)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M247.043 115L240.277 87.9101L240.163 87.8241L125.518 3L125.043 3.63388L239.574 88.3719L245.736 113.044L137.286 32.8066L136.807 33.436L247.043 115Z",
    fill: "url(#paint73_linear_1857_4481)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M138.838 30.5967C137.512 29.6043 135.632 29.8787 134.64 31.205C133.647 32.5312 133.922 34.4109 135.248 35.4033C136.574 36.3957 138.454 36.1213 139.446 34.795C140.439 33.4688 140.164 31.5891 138.838 30.5967Z",
    fill: "url(#paint74_linear_1857_4481)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M270.038 106L270.043 105.232L251.283 105.219L236.55 93L236.043 93.5837L250.991 105.987L270.038 106Z",
    fill: "url(#paint75_linear_1857_4481)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M234.102 96.2884C232.839 95.2174 232.684 93.3226 233.755 92.0594C234.826 90.7962 236.72 90.6406 237.984 91.7116C239.247 92.7826 239.402 94.6774 238.331 95.9406C237.26 97.2038 235.366 97.3594 234.102 96.2884Z",
    fill: "url(#paint76_linear_1857_4481)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M257.231 174.415L257.841 173.918L240.776 152.916L240.713 152.88L187.61 121.855L187.213 122.534L240.252 153.526L257.231 174.415Z",
    fill: "url(#paint77_linear_1857_4481)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M187.039 125.241C185.426 124.954 184.352 123.414 184.639 121.801C184.926 120.189 186.466 119.115 188.079 119.402C189.691 119.689 190.765 121.229 190.478 122.841C190.191 124.454 188.651 125.528 187.039 125.241Z",
    fill: "url(#paint78_linear_1857_4481)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M339.3 201.079L339.698 200.396L308.774 182.328L274.463 183.598L208.92 145.301L208.523 145.983L274.264 184.394L308.575 183.124L339.3 201.079Z",
    fill: "url(#paint79_linear_1857_4481)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M210.344 143.158C208.929 142.33 207.116 142.81 206.289 144.22C205.461 145.635 205.941 147.448 207.351 148.275C208.766 149.102 210.579 148.623 211.406 147.213C212.233 145.798 211.754 143.985 210.344 143.158Z",
    fill: "url(#paint80_linear_1857_4481)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M225.243 170.416L244.13 167.152L243.994 166.374L225.392 169.588L208.513 159.725L208.115 160.407L225.243 170.416Z",
    fill: "url(#paint81_linear_1857_4481)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M206.948 162.7C205.533 161.872 205.058 160.06 205.885 158.645C206.713 157.23 208.525 156.755 209.94 157.582C211.355 158.41 211.83 160.222 211.003 161.637C210.175 163.052 208.363 163.527 206.948 162.7Z",
    fill: "url(#paint82_linear_1857_4481)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M250.219 78L251.043 77.9161L249.066 60.9524L233.624 47L233.043 47.5519L248.275 61.3145L250.219 78Z",
    fill: "url(#paint83_linear_1857_4481)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M230.949 48.1498C229.763 46.9913 229.739 45.0923 230.893 43.906C232.052 42.7196 233.951 42.6957 235.137 43.8502C236.323 45.0087 236.347 46.9077 235.193 48.0941C234.034 49.2804 232.135 49.3043 230.949 48.1498Z",
    fill: "url(#paint84_linear_1857_4481)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M275.248 111H276.043V55.6889L236.619 14L236.043 14.5515L275.248 56.0106V111Z",
    fill: "url(#paint85_linear_1857_4481)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M383.738 193L384.043 170.614H339.837L202.594 39L202.043 39.5596L339.514 171.393H383.242L382.941 192.991L383.738 193Z",
    fill: "url(#paint86_linear_1857_4481)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M199.949 41.1485C198.764 39.9908 198.737 38.0916 199.894 36.9064C201.052 35.7211 202.951 35.6937 204.137 36.8515C205.322 38.0092 205.349 39.9084 204.192 41.0936C203.034 42.2789 201.135 42.3063 199.949 41.1485Z",
    fill: "url(#paint87_linear_1857_4481)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M234.949 16.1485C233.764 14.9908 233.737 13.0916 234.894 11.9064C236.052 10.7211 237.951 10.6937 239.137 11.8515C240.322 13.0092 240.349 14.9084 239.192 16.0936C238.034 17.2789 236.135 17.3063 234.949 16.1485Z",
    fill: "url(#paint88_linear_1857_4481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_4481",
    x1: -26.3277,
    y1: 107.823,
    x2: 127.513,
    y2: 1.28941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1857_4481",
    x1: 309.043,
    y1: 425,
    x2: 88.8314,
    y2: 425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1857_4481",
    x1: 311.283,
    y1: 435.998,
    x2: 88.441,
    y2: 435.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1857_4481",
    x1: 310.043,
    y1: 414,
    x2: 84.8365,
    y2: 414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1857_4481",
    x1: 313.725,
    y1: 424.002,
    x2: 85.4381,
    y2: 424.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1857_4481",
    x1: 313.725,
    y1: 424.002,
    x2: 85.4381,
    y2: 424.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1857_4481",
    x1: 371.043,
    y1: 331.5,
    x2: -2.77694,
    y2: 331.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1857_4481",
    x1: 371.043,
    y1: 316.5,
    x2: 116.224,
    y2: 316.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1857_4481",
    x1: 373.622,
    y1: 305,
    x2: 116.043,
    y2: 305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1857_4481",
    x1: 370.043,
    y1: 265,
    x2: 212.779,
    y2: 265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1857_4481",
    x1: 350.319,
    y1: 271,
    x2: 213.043,
    y2: 271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1857_4481",
    x1: 371.043,
    y1: 281.5,
    x2: 86.8129,
    y2: 281.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1857_4481",
    x1: 338.177,
    y1: 282.171,
    x2: 87.4942,
    y2: 282.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1857_4481",
    x1: 365.043,
    y1: 227,
    x2: 173.825,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1857_4481",
    x1: 342.575,
    y1: 221,
    x2: 173.039,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1857_4481",
    x1: 271.62,
    y1: 157.621,
    x2: 96.4817,
    y2: 37.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1857_4481",
    x1: 255.414,
    y1: 139.823,
    x2: 101.573,
    y2: 33.2894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1857_4481",
    x1: 231.894,
    y1: 182.966,
    x2: 149.137,
    y2: 137.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1857_4481",
    x1: 225.402,
    y1: 173.873,
    x2: 152.588,
    y2: 133.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1857_4481",
    x1: 301.745,
    y1: 178.282,
    x2: 228.635,
    y2: 128.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1857_4481",
    x1: 306.654,
    y1: 173.747,
    x2: 232.665,
    y2: 122.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1857_4481",
    x1: 250.043,
    y1: 208.5,
    x2: 35.8059,
    y2: 208.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1857_4481",
    x1: 224.844,
    y1: 203,
    x2: 36.039,
    y2: 203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1857_4481",
    x1: 260.043,
    y1: 243.506,
    x2: 226.274,
    y2: 243.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1857_4481",
    x1: 261.845,
    y1: 243,
    x2: 227.043,
    y2: 243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1857_4481",
    x1: 371.043,
    y1: 235.502,
    x2: 132.232,
    y2: 235.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1857_4481",
    x1: 375.092,
    y1: 232,
    x2: 133.043,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1857_4481",
    x1: 371.043,
    y1: 251.998,
    x2: 191.223,
    y2: 251.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1857_4481",
    x1: 373.009,
    y1: 256,
    x2: 191.048,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1857_4481",
    x1: 210.856,
    y1: 441.446,
    x2: 176.364,
    y2: 610.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1857_4481",
    x1: 186.238,
    y1: 436.425,
    x2: 151.747,
    y2: 605.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1857_4481",
    x1: 227.038,
    y1: 502.441,
    x2: 204.417,
    y2: 613.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1857_4481",
    x1: 257.494,
    y1: 508.653,
    x2: 234.873,
    y2: 619.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1857_4481",
    x1: 181.631,
    y1: 561.226,
    x2: 168.983,
    y2: 623.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1857_4481",
    x1: 209.471,
    y1: 566.909,
    x2: 196.823,
    y2: 628.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1857_4481",
    x1: 159.535,
    y1: 418.491,
    x2: 136.91,
    y2: 529.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1857_4481",
    x1: 87.279,
    y1: 403.749,
    x2: 64.6539,
    y2: 514.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1857_4481",
    x1: 140.918,
    y1: 464.696,
    x2: 128.74,
    y2: 524.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1857_4481",
    x1: 107.54,
    y1: 457.889,
    x2: 95.3667,
    y2: 517.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1857_4481",
    x1: 127.819,
    y1: 497.627,
    x2: 115.374,
    y2: 558.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1857_4481",
    x1: 118.095,
    y1: 495.647,
    x2: 105.65,
    y2: 556.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1857_4481",
    x1: 246.368,
    y1: 551.9,
    x2: 242.168,
    y2: 572.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1857_4481",
    x1: 284.124,
    y1: 559.603,
    x2: 279.924,
    y2: 580.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1857_4481",
    x1: 250.043,
    y1: 353,
    x2: 161.218,
    y2: 353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1857_4481",
    x1: 250.613,
    y1: 347.995,
    x2: 161.043,
    y2: 347.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1857_4481",
    x1: 235.043,
    y1: 364.502,
    x2: 199.282,
    y2: 364.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1857_4481",
    x1: 235.939,
    y1: 371,
    x2: 199.043,
    y2: 371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1857_4481",
    x1: 292.043,
    y1: 402.5,
    x2: 64.7907,
    y2: 402.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1857_4481",
    x1: 292.05,
    y1: 397.345,
    x2: 65.5754,
    y2: 397.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1857_4481",
    x1: 292.043,
    y1: 245.5,
    x2: 64.7907,
    y2: 245.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1857_4481",
    x1: 265.808,
    y1: 240.175,
    x2: 66.4713,
    y2: 240.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1857_4481",
    x1: 379.047,
    y1: 357.998,
    x2: 159.043,
    y2: 357.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6F611E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D7801",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9A7704",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#957609",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8E7311",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#85701B",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7A6D27",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736B2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1857_4481",
    x1: 380.515,
    y1: 363.502,
    x2: 172.043,
    y2: 363.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1857_4481",
    x1: 155.043,
    y1: 370,
    x2: 117.791,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1857_4481",
    x1: 155.121,
    y1: 364.5,
    x2: 117.043,
    y2: 364.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1857_4481",
    x1: 274.043,
    y1: 385.498,
    x2: 236.787,
    y2: 385.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1857_4481",
    x1: 269.685,
    y1: 390,
    x2: 237.043,
    y2: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1857_4481",
    x1: 373.247,
    y1: 203.056,
    x2: 69.0178,
    y2: 199.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1857_4481",
    x1: 376.365,
    y1: 184.197,
    x2: 69.0431,
    y2: 180.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1857_4481",
    x1: 373.277,
    y1: 188.968,
    x2: 90.9994,
    y2: 185.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1857_4481",
    x1: 376.546,
    y1: 165.975,
    x2: 90.0312,
    y2: 162.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1857_4481",
    x1: 120.511,
    y1: 187.921,
    x2: 120.586,
    y2: 180.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6F611E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D7801",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9A7704",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#957609",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8E7311",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#85701B",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7A6D27",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736B2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1857_4481",
    x1: 105.036,
    y1: 187.4,
    x2: 105.109,
    y2: 180.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6F611E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D7801",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9A7704",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#957609",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8E7311",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#85701B",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7A6D27",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736B2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1857_4481",
    x1: 274.277,
    y1: 480.512,
    x2: 250.353,
    y2: 505.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1857_4481",
    x1: 268.792,
    y1: 478.247,
    x2: 245.919,
    y2: 501.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1857_4481",
    x1: 295.708,
    y1: 446.227,
    x2: 230.192,
    y2: 514.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1857_4481",
    x1: 273.396,
    y1: 437.647,
    x2: 212.908,
    y2: 498.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1857_4481",
    x1: 262.578,
    y1: 414.052,
    x2: 179.699,
    y2: 496.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1857_4481",
    x1: 249.838,
    y1: 419.205,
    x2: 176.911,
    y2: 492.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1857_4481",
    x1: 279.931,
    y1: 407.899,
    x2: 197.053,
    y2: 490.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1857_4481",
    x1: 267.834,
    y1: 414.209,
    x2: 194.907,
    y2: 487.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1857_4481",
    x1: 317.043,
    y1: 358,
    x2: 317.043,
    y2: 531.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1857_4481",
    x1: 238.545,
    y1: 384.509,
    x2: 238.545,
    y2: 531.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1857_4481",
    x1: 251.881,
    y1: 108.738,
    x2: 119.343,
    y2: 6.3534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1857_4481",
    x1: 246.266,
    y1: 116.622,
    x2: 112.701,
    y2: 14.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1857_4481",
    x1: 266.052,
    y1: 110.481,
    x2: 238.842,
    y2: 86.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1857_4481",
    x1: 262.072,
    y1: 116.646,
    x2: 233.777,
    y2: 92.0274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1857_4481",
    x1: 260.024,
    y1: 170.27,
    x2: 182.982,
    y2: 124.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1857_4481",
    x1: 262.024,
    y1: 166.919,
    x2: 184.981,
    y2: 120.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1857_4481",
    x1: 334.369,
    y1: 209.302,
    x2: 211.438,
    y2: 135.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1857_4481",
    x1: 329.237,
    y1: 217.868,
    x2: 206.302,
    y2: 144.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1857_4481",
    x1: 241.011,
    y1: 172.355,
    x2: 209.119,
    y2: 153.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1857_4481",
    x1: 237.786,
    y1: 177.73,
    x2: 205.894,
    y2: 158.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1857_4481",
    x1: 254.897,
    y1: 74.3485,
    x2: 229.204,
    y2: 46.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1857_4481",
    x1: 254.151,
    y1: 67.1077,
    x2: 230.917,
    y2: 43.8741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1857_4481",
    x1: 290.098,
    y1: 96.8632,
    x2: 219.434,
    y2: 26.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1857_4481",
    x1: 384.043,
    y1: 116.002,
    x2: 200.008,
    y2: 116.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1857_4481",
    x1: 384.642,
    y1: 38.9977,
    x2: 199.62,
    y2: 38.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1857_4481",
    x1: 419.642,
    y1: 13.9977,
    x2: 234.62,
    y2: 13.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCircuit);
export default __webpack_public_path__ + "static/media/leftCircuit.0725ef458b3bb42fbd80fba572f53113.svg";
export { ForwardRef as ReactComponent };